// extracted by mini-css-extract-plugin
export const container = "image-module--container--2TXbl";
export const imageWrapper = "image-module--imageWrapper--1oXhI";